import { render } from "./PageWrapper.vue?vue&type=template&id=6f4eaf8a&scoped=true&ts=true"
import script from "./PageWrapper.ts?vue&type=script&lang=ts"
export * from "./PageWrapper.ts?vue&type=script&lang=ts"

import "./PageWrapper.scss?vue&type=style&index=0&id=6f4eaf8a&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4eaf8a"]])

export default __exports__